module.exports = __webpack_public_path__ + "img/sturmschaeden.c6c4f43e.svg";